import React from "react";
import { Modal, Form, Button } from "react-bootstrap";
const TrancheDeleteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  handleDeleteModal,
}) => {
  return (
    <React.Fragment>
      <Modal
        as={Modal.Dialog}
        centered
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
      >
        <Modal.Header>
          <Modal.Title className="h6">Delete Tranche</Modal.Title>
          <Button
            variant="close"
            aria-label="Close"
            onClick={() => setShowDeleteModal(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <Form.Label>
            Are you sure ? You wants to delete this tranche.
          </Form.Label>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="text-white ms-auto"
            onClick={handleDeleteModal}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default TrancheDeleteModal;
